import { useCallback } from 'react';

import { create, show, useModal } from '@ebay/nice-modal-react';

import PromoteToMainDrawDialog, {
  type PromoteToMainDrawDialogProps,
} from 'components/dialogs/promoteToMainDraw/PromoteToMainDrawDialog';

const Modal = create(({ ...props }: PromoteToMainDrawDialogProps) => {
  const modal = useModal();
  return <PromoteToMainDrawDialog closeDialog={modal.hide} isOpen={modal.visible} {...props} />;
});

export const usePromoteToMainDrawDialog = () =>
  useCallback((props?: PromoteToMainDrawDialogProps) => show(Modal, { ...props }), []);
